"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var contact_1 = require("./page/contact");
var index_1 = require("./page/index");
var flexible_1 = require("./page/flexible");
var stores_1 = require("./page/stores");
var faq_1 = require("./page/faq");
var about_1 = require("./page/about");
var store_1 = require("./page/store");
var subscribe_1 = require("./page/subscribe");
var bundlecollection_1 = require("./page/bundlecollection");
var bundlelinks_1 = require("./page/bundlelinks");
var bundlelist_1 = require("./page/bundlelist");
var wishlist_1 = require("./wishlist");
var PageTemplate = /** @class */ (function (_super) {
    __extends(PageTemplate, _super);
    function PageTemplate() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PageTemplate.prototype.render = function () {
        // conditionally render the faq page if the faq section template exists
        if (this.props.data.section.faq) {
            return React.createElement(faq_1.FaqPageTemplate, __assign({}, this.props));
        }
        var templates = {
            contact: React.createElement(contact_1.ContactPageTemplate, __assign({}, this.props)),
            flexible: React.createElement(flexible_1.FlexiblePageTemplate, __assign({}, this.props)),
            stores: React.createElement(stores_1.StoresPageTemplate, __assign({}, this.props)),
            store: React.createElement(store_1.StorePageTemplate, __assign({}, this.props)),
            about: React.createElement(about_1.AboutPageTemplate, __assign({}, this.props)),
            subscribe: React.createElement(subscribe_1.SubscribePageTemplate, __assign({}, this.props)),
            bundlecollection: React.createElement(bundlecollection_1.BundleCollectionPageTemplate, __assign({}, this.props)),
            bundlelinks: React.createElement(bundlelinks_1.BundleLinksPageTemplate, __assign({}, this.props)),
            bundlelist: React.createElement(bundlelist_1.BundleListPageTemplate, __assign({}, this.props)),
            swym: React.createElement(wishlist_1.WishlistPageTemplate, __assign({}, this.props))
        };
        return templates[this.props.data.template.suffix] || React.createElement(index_1.DefaultPageTemplate, __assign({}, this.props));
    };
    return PageTemplate;
}(React.Component));
exports.PageTemplate = PageTemplate;
